module.exports = __webpack_public_path__ + "static/media/park2008.7bfedd1f.jpg";